(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menu = exports.fixedHeader = void 0;

var fixedHeader = function fixedHeader() {
  var header = document.querySelector('.header');
  window.addEventListener('scroll', function () {
    if (window.pageYOffset !== 0) {
      header.classList.add('header--fixed');
    } else {
      header.classList.remove('header--fixed');
    }
  });
};

exports.fixedHeader = fixedHeader;

var menu = function menu() {
  var burger = document.querySelector('.header__menu-toggle');
  burger.addEventListener('click', function () {
    document.body.classList.toggle('nav-active');
  });
  var menu = document.querySelector('.header__menu');
  menu.addEventListener('click', function (event) {
    if (event.target.nextElementSibling.classList.contains('sub-menu')) {
      event.preventDefault();
    }
  });
};

exports.menu = menu;

},{}],2:[function(require,module,exports){
"use strict";

var _header = require("./components/header");

(0, _header.menu)();
(0, _header.fixedHeader)();
/* Lightbox gallery */

if (document.querySelector('.gallery__grid')) {
  jQuery('.gallery__grid__item').simpleLightbox();
}

var counter = document.querySelector('.counter');

if (counter) {
  var countDownDate = new Date("Apr 3, 2020 20:00:00").getTime();
  var x = setInterval(function () {
    var now = new Date().getTime();
    var distance = countDownDate - now;
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
    var seconds = Math.floor(distance % (1000 * 60) / 1000);
    jQuery('.counter__days').html(days < 10 ? '0' + days : days);
    jQuery('.counter__hours').html(hours < 10 ? '0' + hours : hours);
    jQuery('.counter__minutes').html(minutes < 10 ? '0' + minutes : minutes);
    jQuery('.counter__seconds').html(seconds < 10 ? '0' + seconds : seconds);

    if (distance < 0) {
      clearInterval(x);
      counter.style.display = 'none';
    }
  }, 1000);
}
/* Helpers */


function isMobile() {
  return window.innerWidth <= 1024 ? true : false;
}

},{"./components/header":1}]},{},[2]);
